module.exports = __webpack_public_path__ + "static/media/data-ana.d38a7b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/data-ana.png
// module id = 323
// module chunks = 6